<template>
  <Drawer slideout-id="account-slideout" :provider="useAccountSlideout" @close-slideout="tagAccountDrawerClose">
    <AccountContent />
  </Drawer>
</template>

<script setup>
import Drawer from './Drawer.common';
import useAccountSlideout from '~/composables/features/useAccountSlideout';
import AccountContent from '../account/AccountContent.common';
import { tagAccountDrawerClose } from '#shared/features/analytics/accountTags';
</script>

<style lang="scss">
#account-slideout {
  width: 428px;
}
</style>

<style lang="scss" brand="bcom">
#account-slideout .nav-slideout-close {
  margin-top: 2px;
}
</style>
